import Vue from 'vue'
import Element from 'element-ui'
import i18n from '@/i18n'
import { syncElementLocale } from '@/i18n/element-locale'

syncElementLocale(i18n.locale)

Vue.use(Element, {
  size: 'small',
  i18n: function (key, value) {
    return i18n.t(key, value)
  },
})
